

const view = /*html*/`
    <style>
        .live-shadow {
            -webkit-box-shadow: 0px 0px 8px 2px rgba(159,229,13,1);-moz-box-shadow: 0px 0px 8px 2px rgba(159,229,13,1);box-shadow: 0px 0px 8px 2px rgba(159,229,13,1);
        }
        .table-custom
        {
            border-collapse: separate;
            border-spacing: 0 0.45rem;
        }
    </style>
    
    <div id="kt_content_container" class="container-xxl">        
        <div class="d-flex flex-column">
                
            <div class="flex-row-fluid">
                <!--<div class="card mb-4">
                    <div class="card-header border-0 flex-nowrap">
                        <h3 class="card-title gap-3">
                            
                            
                        </h3>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end">
                               
                            </div>                            
                        </div>
                    </div>
                </div>

                <div class="d-table w-100 servers-table" style="border-collapse: separate;border-spacing: 0 0.75rem;">
                    <div class="d-table-row fw-bold text-gray-800 teko-semibold fs-4 bg-gray-100">
                        <div class="d-table-cell py-2 px-3 ps-4 rounded-start">
                            <span class="text-dark">#</span>
                        </div>
                        <div class="d-table-cell py-2 px-3 text-center">
                            <span class="text-dark">Players</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark"></span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Score</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Location</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Ping</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Map</span>
                        </div>
                        <div class="d-table-cell py-2 px-3">
                            <span class="text-dark">Anticheat</span>
                        </div>
                        <div class="d-table-cell py-2 px-3 pe-4 rounded-end text-center">
                            <span class="text-dark text-center">Join</span>
                        </div>
                    </div>
                    <div class="d-table-row servers-list servers-live">
                        <div class="text-gray-900 fs-6 ps-4 text-uppercase teko-header">Live</div>
                    </div>
                    <div class="d-table-row servers-list servers-wait">
                        <div class="text-gray-900 fs-6 ps-4 text-uppercase teko-header">Waiting</div>
                    </div>                    
                </div>-->


                <!--begin::Table container-->
                <div class="table-responsive">
                    <!--begin::Table-->
                    <table class="table table-custom align-middle gs-0 gy-4">
                        <!--begin::Table head-->
                        <thead>
                            <tr class="fw-bold text-gray-800 teko-semibold fs-4" style="background-color: #1b1b1b">
                                <th class="ps-4 rounded-start min-w-75px text-center" data-i18n="stats.type">Type</th>
                                <th class="text-center" data-i18n="stats.players">Players</th>
                                <th class="d-none d-lg-block"></th>
                                <th class="text-center" data-i18n="stats.score">Score</th>
                                <th class="text-center" data-i18n="stats.loc">Location</th>                                                               
                                <th class="text-center">Ping</th>
                                <th class="" data-i18n="stats.map">Map</th>
                                <th class="" data-i18n="stats.ac">Anticheat</th>
                                <th class="text-nowrap rounded-end pe-4 text-center" data-toggle="tooltip" title="" data-i18n="">Join</th>                                
                            </tr>
                        </thead>
                        <!--end::Table head-->

                        <!--begin::Table body-->
                        <tbody class="table-players-body position-relative">
                            <tr class="bg-light bg-opacity-25 servers-list servers-live">
                                <td class="px-4 rounded-start rounded-end" colspan="9">
                                    <div class="text-gray-900 fs-6 ps-4 text-uppercase teko-header">Live</div>
                                </td>
                            </tr>
                            <tr class="bg-light bg-opacity-25 servers-list servers-wait">
                                <td class="px-4 rounded-start rounded-end" colspan="9">
                                    <div class="text-gray-900 fs-6 ps-4 text-uppercase teko-header">Waiting</div>
                                </td>
                            </tr>
                        </tbody>
                        <!--end::Table body-->
                    </table>
                    <!--end::Table-->
                </div>
                <!--end::Table container-->
            </div>
        </div>
    </div>


`;


export default view;